import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { usePurchasePreview } from "@/hooks/purchases/purchases";
import { formatMilesDecimalNew, formatUnitMeasure } from "@/services/Utils";
import { ESTATE_PARENT_SINGULAR, ESTATE_SINGULAR } from "@/services/estateLabels";

import Fetching from "@/components/Fetching/Fetching";

import classes from "./PurchasePreview.module.scss";

const PurchasePreview = ({ show, setShow, data, type, handleConfirm }) => {
	const [alerts, setAlerts] = useState([]);

	const { data: response, isLoading } = usePurchasePreview({ ...data, show });

	const handleClose = () => setShow(false);

	const handleLocalConfirm = () => {
		handleConfirm(response);
		handleClose();
	};

	useEffect(() => {
		if (response && response.alerts && response.alerts.length > 0) {
			const uniqueAlerts = new Map();

			response.alerts.forEach((alert) => {
				if (!uniqueAlerts.has(alert.id)) {
					uniqueAlerts.set(alert.id, alert);
				}
			});

			setAlerts(Array.from(uniqueAlerts.values()));
		} else {
			setAlerts([]);
		}
	}, [response]);

	return (
		<Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
			<Modal.Header closeButton>
				<Modal.Title className={classes.title}>{type === "sale" ? "Vista previa Factura" : "Vista previa Guía de Despacho"}</Modal.Title>
			</Modal.Header>
			<Modal.Body className={classes.previewModal}>
				{isLoading ? (
					<Fetching topMargin={"1em"} message={`Estamos procesando la información, por favor espere un momento.`} />
				) : (
					<>
						{alerts.map((alert, idx) => (
							<div key={idx} className={classes.alert} dangerouslySetInnerHTML={{ __html: alert }} />
						))}

						<div className={classes.tableMain}>
							<div className={classes.row}>
								<div className={classes.cell}>
									<div className={classes.field}>
										<strong>Razón Social:</strong> {response?.business_name || "-"}
									</div>
									<div className={classes.field}>
										<strong>{ESTATE_PARENT_SINGULAR}:</strong> {response?.estate_parent_name || "-"}
									</div>
									<div className={classes.field}>
										<strong>{ESTATE_SINGULAR}:</strong> {response?.estate_name || "-"}
									</div>
								</div>
								<div className={classes.cell}>
									<div className={classes.field}>
										<strong>Distribuidor:</strong> {response?.dealer_name || "-"}
									</div>
									<div className={classes.field}>
										<strong>RUT Distribuidor:</strong> {response?.rut_dealer || "-"}
									</div>
									<div className={classes.field}>
										<strong>Moneda:</strong> {Number(response?.type_currency_id) === 1 ? "CLP" : "USD"}
									</div>
								</div>
							</div>
						</div>

						<table className={classes.tableDetail}>
							<thead>
								<tr className={classes.tableHeader}>
									<th style={{ width: "30%", textAlign: "left" }}>Producto</th>
									<th style={{ width: "10%", textAlign: "right" }}>
										Cant. <br />
										Envases.
									</th>
									<th style={{ width: "10%", textAlign: "right" }}>
										Contenido <br />
										por Envase
									</th>
									<th style={{ width: "15%", textAlign: "right" }}>
										Total <br /> Producto
									</th>
									<th style={{ width: "5%" }}>U.M</th>
									<th style={{ width: "15%" }}>Genérico</th>
									<th style={{ width: "15%", textAlign: "right" }}>
										Precio <br />
										Neto Total
									</th>
								</tr>
							</thead>
							<tbody>
								{response?.items.map((item, index) => {
									const unitMeasure = item.units_enabled.find((unit) => Number(unit.value) === Number(item.value_unit_measurement));

									return (
										<tr key={index} className={classes.tableRow}>
											<td>{item.product_name}</td>
											<td style={{ textAlign: "right" }}>{formatMilesDecimalNew(item.quantity) || 0}</td>
											<td style={{ textAlign: "right" }} className={!item.container_content ? classes.highlight : ""}>
												{formatMilesDecimalNew(item.container_content) || "-"}
											</td>
											<td style={{ textAlign: "right" }}>{formatMilesDecimalNew(item.total_product) || "0.00"}</td>
											<td style={{ textAlign: "center" }}>
												{unitMeasure ? unitMeasure.label : formatUnitMeasure(item.unit_measurement)}
											</td>
											<td>
												{data.productCustomer?.find((generic) => {
													return String(generic.value) === String(item.save_as);
												})?.label || "-"}
											</td>
											<td style={{ textAlign: "right" }}>${formatMilesDecimalNew(item.price_total) || "0.00"}</td>
										</tr>
									);
								})}
							</tbody>
						</table>

						<h5 className={classes.total}>
							Total {type === "sale" ? "Factura" : "Guía de Despacho"}: {formatMilesDecimalNew(response?.pricing_total)}
						</h5>
					</>
				)}
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" size="sm" onClick={handleClose} disabled={isLoading}>
					MODIFICAR
				</Button>
				<Button variant="success" size="sm" onClick={handleLocalConfirm} disabled={isLoading}>
					CONFIRMAR y GUARDAR
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default PurchasePreview;
